import React from "react";

const TeamSection = () => {
  const teamCard = [
    {
      img: "/image/team/img-1.jpg",
      title: "Alex Grey",
      content: "CEO, Director",
    },
    {
      img: "/image/team/img-2.jpg",
      title: "Ashton Kutsher",
      content: "Soft Engineer",
    },
    {
      img: "/image/team/img-3.jpg",
      title: "John Ferris",
      content: "Frontend Developer",
    },
    {
      img: "/image/team/img-4.jpg",
      title: "Balinda Bing",
      content: "Social Media Expert",
    },
    {
      img: "/image/team/img-5.jpg",
      title: " Alforque",
      content: "Graphic Designer",
    },
  ];

  return (
    <div className="team-section section-padding" id="team">
      <div className="container">
        <div className="row">
          {/* TITLE SECTION */}
          <div className="col-lg-6 col-sm-8 mx-auto">
            <div className="team-title text-center">
              <h2 className="text-white mb-md-5 mb-4" data-aos='zoom-in' >
                Meet Our Crypto Experts
              </h2>
              <p data-aos='fade-up' >
                NFTs Can Be Used To Represent Items Such As Photos, Videos,
                Audio, And Other Types Of Digital Files.
              </p>
            </div>
          </div>
        </div>
        <div className="row g-4 mt-5 d-flex align-items-center  justify-content-center">
          {/* CONTENT SECTION */}

          {teamCard.map((element, index) => {
            return (
              <div key={index} className="col-xl-2 col-lg-3 col-sm-6 col-md-4 col-6" data-aos='fade-up' >
                <div className="team-card text-center">
                  <img src={element.img} alt="" />
                  <div className="team-body  mt-4 text-center">
                    <h4 className="mb-3">{element.title}</h4>
                    <p>{element.content}</p>
                    <i className="fa fa-linkedin d-inline-block me-4"></i>
                    <i className="fa fa-twitter"></i>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TeamSection;
